import { Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import fetchfromAPI from '../../utils/fetchfromAPI'
import SideBar from './SideBar'
import Video from './Video'

const Feed = () => {
  const [SelectedCategory,setSelectedCategory]=useState("New")
  const [videos,setVideos]=useState([])
  useEffect(()=>{
    fetchfromAPI(`search?part=snippet&q=${SelectedCategory}`).then((data)=>setVideos(data.items))

  }, [SelectedCategory])
  return (
    <div>
      <Stack sx={{flexDirection:{sx:"column",md:"row"}}}>
      <Box sx={{height:{sx:"auto",md:"92vh"},borderRight:"1px solid #3d3d3d",px:{sx:0,md:2}}}>
          <SideBar SelectedCategory={SelectedCategory} setSelectedCategory={setSelectedCategory} />

      <Typography sx={{mt:15}}>
        CopyRight -{new Date().getFullYear()} Scarry_Parrot
      </Typography>
      </Box>
      <Box sx={{}} className="overflow-y-auto px-3 h-[90vh]">
          <Typography className='px-4' variant='h4' fontWeight="bold" mb={2} sx={{}}>
              {SelectedCategory}<span className=' ml-3 text-[#F31503]' >Videos</span>
          </Typography>
          <Video videos={videos} setVideos={setVideos} />
      </Box>
      </Stack>
    </div>
  )
}

export default Feed
